import React from "react";
import { Link } from "react-router-dom";

interface RelatedPost {
  title: string;
  slug: string;
  imageUrl?: string;
}

interface RelatedPostsProps {
  posts: RelatedPost[];
}

const RelatedPosts: React.FC<RelatedPostsProps> = ({ posts }) => {
  if (!posts.length) return null;

  return (
    <div className="bg-law-black-600/70 backdrop-blur-sm rounded-xl shadow-md p-4 mb-5 sidebar-item border border-justice-gold-500/20">
      <h3 className="font-bold text-base text-white mb-3">Related Articles</h3>
      <div className="space-y-3">
        {posts.map((post, index) => (
          <Link
            key={index}
            to={`/${post.slug}`}
            className="flex items-center p-2 -mx-2 rounded-lg hover:bg-law-black-500/50 transition-colors group"
          >
            <div>
              <h4 className="text-sm text-cannabis-green-400 font-medium group-hover:text-cannabis-green-300 transition-colors line-clamp-2">
                {post.title}
              </h4>
              <p className="text-gray-400 text-xs mt-1">Read more</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedPosts;
